import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../axios";
import { useLocation, useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [sessionExpired, setSessionExpired] = useState(false);
  useEffect(() => {
    const handler = () => {
      setUser(null);
      setSessionExpired(true);
    };

    window.addEventListener("session-expired", handler);
    return () => window.removeEventListener("session-expired", handler);
  }, []);
  let apiRoute = "/api/user";
  const guestRoutes = [
    "/",
    "/login",
    "/register",
    "/forgotpassword",
    "/resetpassword",
    "/verify-email",
    "/faq",
    "/contact",
    "/termsofuse",
    "/privacypolicy",
    "/fractions",
    "/hires"
  ];
  if (location.pathname.startsWith("/admin_dashboard")) {
    apiRoute = "/api/admin_dashboard/user";
  }
  useEffect(() => {
    setLoaded(false);
    axios
      .get(apiRoute)
      .then((res) => {
        setUser(res.data);
        setLoaded(true);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          setUser(null);
          setSessionExpired(true);
          if (!guestRoutes.includes(location.pathname)) {
            navigate("/login", {
              replace: true,
              state: { from: location.pathname + location.search },
            });
          }
        }
        setLoaded(true);
      });
  }, [location.pathname]);

  return (
    <AuthContext.Provider value={{ user, setUser, loaded, sessionExpired }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
